import { call, takeEvery } from "redux-saga/effects";
import { Action } from "re-reduced";

import actions from "@state/actions";
import { ScannedTicket } from "@state/types";
import audio from "@util/audio";

export default function* scanSounds() {
  yield takeEvery(
    actions.scanTicketOnline.success.type,
    function* (action: Action<ScannedTicket>) {
      yield call(audio.scanResult, action.payload.status);
    }
  );
  yield takeEvery(actions.scanTicketOnline.failure.type, function* () {
    yield call(audio.scanError);
  });
  yield takeEvery(actions.setScannedTicketError.type, function* () {
    yield call(audio.scanResult, "error");
  });
  yield takeEvery(
    [
      actions.scanTicket.type,
      actions.clearScanTicket.type,
      actions.logout.type,
    ],
    function* () {
      yield call(audio.stop);
    }
  );
}
